import { createContext } from "react";

const SearchContext = createContext({
    isSearching: false,
    searchInput: '',
    setSearchInput: () => {},
    onChangeSearch: () => {},
    fetchMoreData: () => {},
    lastProductObj: undefined,
    products: undefined,
    setProducts: () => {},
    hasMore: false,
    setHasMore: () => {},
    perPage: undefined
});

export default SearchContext;
